// @ts-nocheck
import { ThemeEvents } from '@theme/events';
import CartManager from './cart-manager.js';

function applyUpsellVisibility(cart) {
  if (!cart?.items) return;

  const cartIds = cart.items.map((item) => item.product_id);
  document.querySelectorAll('.upsellCarousel__slide').forEach((slide) => {
    const productId = parseInt(slide.getAttribute('product-id'), 10);
    if (cartIds.includes(productId)) {
      slide.style.display = 'none';
      slide.classList.add('is-hidden');
    }
  });

  const swiperEl = document.querySelector('.upsellCarousel__carousel');
  if (swiperEl?.swiper) {
    swiperEl.swiper.update();
  }
}

async function updateUpsellVisibility(event) {
  try {
    const eventCart = event?.detail?.resource?.cart;
    if (eventCart) {
      applyUpsellVisibility(eventCart);
      return;
    }

    const managerCart = CartManager.getInstance().getState();
    if (managerCart) {
      applyUpsellVisibility(managerCart);
      return;
    }

    const bootstrapCart = window.getBootstrapCart?.();
    if (bootstrapCart) {
      applyUpsellVisibility(bootstrapCart);
      return;
    }

    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await response.json();
    applyUpsellVisibility(cart);
  } catch (e) {
    console.error('Cart update error:', e);
  }
}

function initUpsellSwiper() {
  const upsellEl = document.querySelector('.upsellCarousel__carousel');
  if (!upsellEl) return;

  const run = () => {
    if (!upsellEl.classList.contains('swiper-initialized')) {
      new Swiper(upsellEl, {
        slidesPerView: 3.2,
        spaceBetween: 10,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          960: { slidesPerView: 3.2, spaceBetween: 10 },
          768: { slidesPerView: 2.2, spaceBetween: 10 },
          0: { slidesPerView: 1.2, spaceBetween: 10 },
        },
        navigation: {
          nextEl: '.upsellCarousel__navButton--next',
          prevEl: '.upsellCarousel__navButton--prev',
        },
      });
    }
    updateUpsellVisibility();
  };

  if (typeof window.whenSwiperReady === 'function') {
    window.whenSwiperReady(run);
  } else if (typeof Swiper !== 'undefined') {
    run();
  }
}

initUpsellSwiper();
document.addEventListener(ThemeEvents.cartUpdate, updateUpsellVisibility);
